module.exports = __webpack_public_path__ + "img/sns-info-text.f57cb2ad.png";